module.exports = __webpack_public_path__ + "img/hero.1daadfc4.png";